/* SessionAgent.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GTcwR2ADO%7Bmargin-inline-start%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02xpxF%7Bwidth%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VxpxF%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaTCRo%7Btransform%3Ascale(.75)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0yKXXaDIqT%7Btransform-origin%3Acenter%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Text } from '@atlaskit/primitives/compiled/text';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { messages } from './messages';
const styles = {
  agent: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC",
  identity: "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT",
  spaced: "_0GTcwR2ADO",
  icon: "_3YEZNOdnbC",
  icon12: "_39xV02xpxF _0jFU0VxpxF",
  icon16: "_39xV02ey7F _0jFU0Vey7F",
  agentAvatar12: "_3iDTPbccYA _1VJPcaTCRo _0yKXXaDIqT"
};
export type SessionIconSize = 12 | 16;
export type SessionAgentDetails = {
  id: string;
  name: string;
  /** Raw signal that this identity represents the default Rovo agent. */
  isRovo?: boolean;
  avatarUrl?: string;
  agentId?: string;
  agentIdentityAccountId?: string;
  agentNamedId?: string;
};
export type SessionAgentProps = {
  agents: ReadonlyArray<SessionAgentDetails>;
  /** Whether to render visible agent names alongside their avatars. */
  showNames?: boolean;
  /** Compatibility override for callers that cannot yet provide `agent.isRovo`. */
  isDefaultAgent?: boolean;
  /** Visual size for agent icons. Defaults to 12. */
  iconSize?: SessionIconSize;
  additionalAgentCount?: number;
  testId?: string;
};

/** Renders the agents participating in a session and an optional overflow count. */
export const SessionAgent = ({
  agents,
  showNames = true,
  isDefaultAgent = false,
  iconSize = 12,
  additionalAgentCount,
  testId
}: SessionAgentProps): React.JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  if (agents.length === 0 && !additionalAgentCount) {
    return null;
  }

  // SessionAgent consumers are already AI Inbox-gated. Keep this local check as
  // a defense-in-depth safeguard if this shared component gains another consumer.
  // The shared ADS gate coordinates geometry with the backend avatar-image rollout.
  const useAdsAvatar = fg('rovo-chat-ai-inbox') && fg('platform-dst-avatar-updated-geometry');
  return <Box as="span" xcss={styles.agent} testId={testId}>
			{agents.map((agent, index) => {
      const agentName = agent.name;
      const shouldUseRovoIcon = agent.isRovo ?? isDefaultAgent;
      const agentAvatar = <AgentAvatar size="xxsmall" imageUrl={agent.avatarUrl} name={agent.name} agentId={agent.agentId} agentIdentityAccountId={agent.agentIdentityAccountId} agentNamedId={agent.agentNamedId} UNSAFE_useAdsAvatar={useAdsAvatar} />;
      return <Box as="span" xcss={cx(styles.identity, index > 0 ? styles.spaced : undefined)} key={agent.id}>
						{shouldUseRovoIcon ? <Flex as="span" xcss={cx(styles.icon, iconSize === 12 ? styles.icon12 : styles.icon16)} alignItems="center" justifyContent="center" aria-hidden={showNames ? true : undefined}>
								<RovoIcon label={agentName} size={iconSize === 12 ? '12' : '16'} />
							</Flex> : <Flex as="span" xcss={cx(styles.icon, iconSize === 12 ? styles.icon12 : styles.icon16)} alignItems="center" justifyContent="center" role={showNames ? undefined : 'img'} aria-label={showNames ? undefined : agentName} aria-hidden={showNames ? true : undefined}>
								{iconSize === 12 ? <Box as="span" xcss={styles.agentAvatar12}>
										{agentAvatar}
									</Box> : agentAvatar}
							</Flex>}
						{showNames ? <Box as="span">{agentName}</Box> : null}
					</Box>;
    })}
			{additionalAgentCount && additionalAgentCount > 0 ? <Box as="span" xcss={agents.length > 0 ? styles.spaced : undefined} role="img" aria-label={formatMessage(messages.additionalAgentsLabel, {
      count: additionalAgentCount
    })}>
					<Text as="span" weight="medium">
						{formatMessage(messages.additionalAgents, {
          count: additionalAgentCount
        })}
					</Text>
				</Box> : null}
		</Box>;
};